import { VaultToken } from '@app/hooks/plugins/useVaults';

export function getToken(item: VaultToken) {
  return {
    contractAddress: item.id,
    symbol: item.symbol,
    decimals: +item.decimals,
    name: item.name
  };
}
